import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';

import FastModal from 'components/FastModal';
import HumiditySwitch from 'contents/HumidityControl/HumiditySwitch';
import {hideTypedModal} from 'stores/actions/typedModalAction';
import {checkAndPumpWater, updateIdleHumidityStatus} from 'stores/business/humidifierBusiness';
import {selectIdleHumidity, selectIsIdleHumidityEnabled} from 'stores/selectors/humidifierSelectors';

function ModalIdleHumidity() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();

  const isIdleEnabled = useSelector(selectIsIdleHumidityEnabled);
  const idleHumidity = useSelector(selectIdleHumidity);

  const [humidityEnabled, setHumidityEnabled] = useState(isIdleEnabled);
  const [humidityValue, setHumidityValue] = useState(idleHumidity);
  const [canProceed, setCanProceed] = useState(false);

  const handleProceed = async () => {
    if (humidityEnabled) {
      const isWaterLevelOk = await dispatch(checkAndPumpWater());
      if (!isWaterLevelOk) return;
    }

    await dispatch(updateIdleHumidityStatus(humidityValue, humidityEnabled));
    dispatch(hideTypedModal());
  };

  const handleCloseModal = () => {
    dispatch(hideTypedModal());
  };

  const idText = 'modal.humidifier.idleHumidityConfirmation';

  const buttons = [
    {
      style: 'primary',
      handlerClick: handleProceed,
      text: formatMessage({id: `${idText}.firstButton`}),
      disabled: !canProceed,
    },
    {
      style: 'secondary',
      handlerClick: handleCloseModal,
      text: formatMessage({id: `${idText}.secondButton`}),
    },
  ];

  const content = (
    <HumiditySwitch
      enabled={isIdleEnabled}
      value={idleHumidity}
      onChangeEnabled={setHumidityEnabled}
      onChangeValue={setHumidityValue}
      handleCanProceed={setCanProceed}
      showInfoIcon
    />
  );

  return (
    <FastModal
      show
      header={formatMessage({id: 'modal.humidifier.idleHumidityConfirmation.title'})}
      content={content}
      btnAction={buttons}
      onClose={handleCloseModal}
      closeDisabled={false}
    />
  );
}

export default ModalIdleHumidity;
